import styled from 'styled-components';
import { theme } from '../../../config';

export const BannerContainer = styled.a``;

export const Banner = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  /* @media ${theme.breakpoints.mobileAndTablet} {
    padding-bottom: 75%;
  } */
`;
